var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-switch"},[_vm._l((_vm.options),function(opt){return [_c('div',{key:opt.val,staticClass:"option",class:{selected: opt.val === _vm.selectedVal},on:{"click":function($event){_vm.clickOnOption(opt)}}},[_vm._v("\n      "+_vm._s(opt.text)+"\n    ")])]})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de879fc4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/LabelSwitch.vue
// module id = null
// module chunks = 